import { render, staticRenderFns } from "./parkingBoxManageList.vue?vue&type=template&id=00a4378d&scoped=true"
import script from "./parkingBoxManageList.vue?vue&type=script&lang=js"
export * from "./parkingBoxManageList.vue?vue&type=script&lang=js"
import style0 from "./parkingBoxManageList.vue?vue&type=style&index=0&id=00a4378d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a4378d",
  null
  
)

export default component.exports